import { useRef, useEffect, useState } from 'react';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { length } from 'ramda';
import useFetchQuery from '../../../../hooks/useFetchQuery';
import { QWidgetsQuery } from '../../../../_graphql/queries/documents/QWidgets';

export default function useWidgetsQuery ({
  args,
  cacheKey,
  collapseIsOpen,
  refetchWidgets,
  setRefetchWidgets,
  setIsLoadingOfferItem
}) {
  const [widgets, setWidgets] = useState([]);
  const forceRefresh = useRef(false);

  const { widgets: allWidgets, isLoading, error, reFetch } = useFetchQuery({
    query: QWidgetsQuery,
    args,
    dataProp: 'widgets',
    defaultData: [],
    cacheKey,
    skip: !collapseIsOpen,
    staleWhileRevalidate: true
  });

  useEffect(() => {
    if (refetchWidgets && reFetch) {
      forceRefresh.current = true;
      reFetch();
      setRefetchWidgets(false);
    }
  }, [reFetch, refetchWidgets, setRefetchWidgets]);

  useEffect(() => {
    setIsLoadingOfferItem && setIsLoadingOfferItem(isLoading);
    if (!isLoading && (isNotNilOrEmpty(allWidgets) || forceRefresh.current)) {
      forceRefresh.current = false;
      setWidgets(allWidgets);
    }
  }, [isLoading, allWidgets, setIsLoadingOfferItem]);

  useEffect(() => {
    if (!isLoading && length(widgets) !== length(allWidgets) && !collapseIsOpen) {
      forceRefresh.current = true;
      reFetch();
    }
  }, [widgets, allWidgets, isLoading, collapseIsOpen, reFetch]);

  return {
    widgets, isLoading, error, reFetch, setWidgets
  };
}
